import ListingExchangeCard from "components/company/cards/ListingExchangeCard";
import FoundedYearCard from "components/company/cards/FoundedYearCard";
import HeadquartersCard from "components/company/cards/HeadquartersCard";
import IndexParticipationCard from "components/company/cards/IndexParticipationCard";
import MarketCapCard from "components/company/cards/MarketCapCard";
import RegistrationDateOrIPOCard from "components/company/cards/RegistrationDateOrIPOCard";
import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";

export default function AmericanCardsContent() {
  const issuer = useAmericanIssuer();

  return (
    <div className="grid grid-cols-1 items-center gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      <MarketCapCard issuer={issuer} />
      <FoundedYearCard issuer={issuer} />
      <RegistrationDateOrIPOCard issuer={issuer} />
      <ListingExchangeCard issuer={issuer} />
      <HeadquartersCard issuer={issuer} />
      <IndexParticipationCard issuer={issuer} />
    </div>
  );
}
